import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { List, ListSubheader } from "@mui/material";
import WorkspaceListTree from "./WorkspaceListTree";

const WorkspaceList = ({
  headerLabel,
  onClick,
  structureTree,
}) => {
  const [structureTreeRoots, setStructureTreeRoots] = useState([]);

  useEffect(() => {
    const newStructureTreeRoots = Object.values(structureTree || {}).filter(
      (x) => x.isRoot
    );
    setStructureTreeRoots(newStructureTreeRoots);
  }, [structureTree]);

  return (
    <List
      component="nav"
      subheader={
        <ListSubheader
          component="div"
          sx={{
            textAlign: "right",
            lineHeight: { xs: "20px", sm: "30px" },
            fontSize: { xs: 10, sm: 11 },
            textTransform: "uppercase",
            px: { xs: "5px", sm: 0 },
          }}
        >
          {headerLabel}
        </ListSubheader>
      }
      sx={{
        width: "100%",
        "& .MuiListItemIcon-root": {
          minWidth: { xs: 24, sm: 30 },
        },
        "& .MuiSvgIcon-root": {
          width: { xs: 16, sm: "inherit" },
          height: { xs: 16, sm: "inherit" },
        },
        "& .MuiListItem-root": {
          paddingTop: { xs: "2px", sm: "4px" },
          paddingBottom: { xs: "2px", sm: "4px" },
          paddingLeft: { xs: "5px", sm: "16px" },
          paddingRight: { xs: "5px", sm: "16px" },
        },
        "& .MuiTypography-root": {
          fontSize: { xs: 11, sm: "inherit" },
        },
      }}
    >
      <WorkspaceListTree
        onClick={onClick}
        structureTreeRoots={structureTreeRoots}
      />
    </List>
  );
};

WorkspaceList.defaultProps = {
  headerLabel: <FormattedMessage id="workspace.workspace" />,
};

WorkspaceList.propTypes = {
  headerLabel: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  // Din komponent anv�nder ett objekt (keyed dictionary), inte en array:
  structureTree: PropTypes.object.isRequired,
};

export default WorkspaceList;
